(function () {
  // Gift card product page only (loaded conditionally by sections/product.liquid
  // when product.gift_card? is true). The initial page render already drops the
  // trailing ".00" via Liquid; this keeps the price under the title in sync when
  // the shopper picks a different denomination, since that update happens in JS.
  function stripCents(text) {
    return text.replace(/\.00(?=\D|$)/g, '');
  }

  function cleanup(section) {
    section.querySelectorAll('[data-product-price], [data-compare-price]').forEach(function (el) {
      var cleaned = stripCents(el.textContent);
      if (cleaned !== el.textContent) el.textContent = cleaned;
    });
  }

  function bind(section) {
    if (section._giftCardPriceBound) return;
    section._giftCardPriceBound = true;
    cleanup(section);
    section.addEventListener('theme:variant:change', function () {
      cleanup(section);
    });
  }

  function init() {
    document.querySelectorAll('[data-gift-card="true"]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
